import type { PushCampaign, PushCampaignAudience } from '../types/data';

export function pushCampaignMapper(pushCampaign): PushCampaign {
  return {
    id: pushCampaign.id,
    name: pushCampaign.name,
    status: pushCampaign.status,
    failedReason: pushCampaign?.failed_reason ?? null,
    scheduledAt: pushCampaign.scheduled_at ?? null,
    title: pushCampaign.title ?? null,
    body: pushCampaign.body ?? '',
    imageUrl: pushCampaign.image_url ?? null,
    deeplink: pushCampaign.deeplink ?? null,
    presentation: pushCampaign.presentation ?? null,
    badgeCount: pushCampaign.badge_count ?? null,
    // `?? null`, never `|| 0` — a campaign whose metrics have never synced has null counters;
    // coercing to 0 makes "not sent yet" indistinguishable from "reached nobody" (mirrors email mapper).
    sendCount: pushCampaign.send_count ?? null,
    deliveredCount: pushCampaign.delivered_count ?? null,
    failedCount: pushCampaign.failed_count ?? null,
    audiences: (pushCampaign.audiences || []).map(mapAudience),
  };
}

// A segment's name comes from a lookup that can fail, in which case it is null; the count is never known
// ahead of the send. Every other audience is passed through as the server sent it.
type ServerAudience = Omit<PushCampaignAudience, 'name' | 'count'> & { name: string | null; count?: number };

function mapAudience(audience: ServerAudience): PushCampaignAudience {
  if (audience?.type !== 'segment') return audience as PushCampaignAudience;

  return { ...audience, name: audience.name || 'Profile segment', count: audience.count ?? -1 };
}
